export class ListAzureSKUsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureSKUsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
